var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",class:{ selected: _vm.selected, filled: _vm.value },style:({
    gridColumnStart: _vm.col,
    gridRowStart: _vm.row,
  }),attrs:{"data-row":_vm.row,"data-col":_vm.col},on:{"click":function($event){return _vm.click($event)},"mouseover":function($event){return _vm.mouseover($event)}}},[_c('drop',{on:{"drop":_vm.handleDrop,"dragenter":_vm.handleEnter}},[_c('drag',{attrs:{"transfer-data":{ 
        from: 'grid', 
        img: _vm.value, 
        thumbUrl: _vm.thumbUrl,
        row: _vm.row, 
        col: _vm.col, 
      }},on:{"dragstart":_vm.startdrag,"dragend":_vm.enddrag}},[(_vm.value)?_c('img',{attrs:{"src":_vm.thumbUrl}}):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }